import React, { useCallback } from 'react';

import { ReadonlyURLSearchParams, useSearchParams } from 'next/navigation';
import { Descendant } from 'slate';

import Element from './components/Element';
import Leaf from './components/Leaf';
import useTenant from 'hooks/useTenant';

interface Node {
  text?: string;
  children?: Node[];
}

type NodeComponentProps = {
  node: Node;
  searchParams?: ReadonlyURLSearchParams;
  hostName?: string;
  enableWidgetStyles?: boolean;
};

const NodeComponent = ({
  node,
  searchParams,
  hostName,
  enableWidgetStyles,
}: NodeComponentProps) => {
  if (node.text || typeof node.text !== 'undefined') {
    return (
      <Leaf attributes={{}} leaf={node}>
        {node.text}
      </Leaf>
    );
  }
  return (
    <Element
      attributes={{}}
      element={node}
      searchParams={searchParams}
      hostName={hostName}
      enableWidgetStyles={enableWidgetStyles}
    >
      {node.children?.map((child: Node, i: React.Key | null | undefined) => (
        <NodeComponent key={i} node={child} searchParams={searchParams} hostName={hostName} />
      ))}
    </Element>
  );
};

function RichTextEditorContentRender({
  text,
  enableWidgetStyles = false,
}: {
  text: Descendant[];
  enableWidgetStyles?: boolean;
}) {
  const tenant = useTenant();
  const searchParams = useSearchParams();

  const Content = useCallback(() => {
    return text?.map((node, i) => {
      return (
        <NodeComponent
          key={i}
          node={node}
          searchParams={searchParams || undefined}
          hostName={tenant?.hostName}
          enableWidgetStyles={enableWidgetStyles}
        />
      );
    });
  }, [text, searchParams, tenant?.hostName, enableWidgetStyles]);

  return (
    <>
      <Content />
    </>
  );
}

export default RichTextEditorContentRender;
